import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addBooks } from '../../redux/book/actions';
import getBooks from '../../redux/book/thunk/getBooks';
import { addFilter } from '../../redux/filter/actions';
import BookCard from '../BookCard/BookCard';
import BookForm from '../BookForm/BookForm';

const MainContent = () => {
    const { books: { books }, filter: { text, all } } = useSelector(state => state)
    const dispatch = useDispatch()
    const handleAllAndFeaturedClick = (value) => {
        dispatch(addFilter({ all: value }))
    }
    const filterWithText = (data) => {
        return data.filter(single => single.name.toLocaleLowerCase().includes(text.toLocaleLowerCase()))
    }
    const filterWithFeatured = (data) => {
        return data.filter(single => single.featured)
    }
    const showData = (data) => {
        return data.map(single => <BookCard key={single.id} {...single}></BookCard>)
    }

    useEffect(() => {
        dispatch(getBooks)
    }, [dispatch])
    return (
        <main className="py-12 2xl:px-6">
            <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
                <div className="order-2 xl:-order-1">
                    <div className="flex items-center justify-between mb-12">
                        <h4 className="mt-2 text-xl font-bold">Book List</h4>
                        <div className="flex items-center space-x-4">
                            <button onClick={() => handleAllAndFeaturedClick(true)} className={`filter-btn ${all ? "active-filter" : ''}`} id="lws-filterAll">All</button>
                            <button onClick={() => handleAllAndFeaturedClick(false)} className={`filter-btn ${!all ? "active-filter" : ''}`} id="lws-filterFeatured">Featured</button>
                        </div>
                    </div>
                    <div className="lws-bookContainer">
                        {
                            all ?
                                text.length ?
                                    showData(filterWithText(books))
                                    :
                                    showData(books)
                                :
                                text.length ?
                                    showData(filterWithText(filterWithFeatured(books)))
                                    :
                                    showData(filterWithFeatured(books))

                        }

                    </div>
                </div>
                <div>
                    <BookForm></BookForm>
                </div>
            </div>
        </main>
    );
};

export default MainContent;